import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import {
  useDeleteSupportTicketMutation,
  useEditSupportTicketMutation,
} from "../../store/Api/supportTicket";
import {
  useEditReAuditMutation,
  useGetReAuditQuery,
} from "../../store/Api/reAudits";
import DuplicateAuditsUi from "./DuplicateAuditsUi";
import { useGetCenQuery } from "../../store/Api/cen";
import { useGetCentreDataQuery } from "../../store/Api/masterDataApi/centre";
import { useCopyAuditsMutation } from "../../store/Api/duplicateAudits";
import { useDispatch, useSelector } from "react-redux";
import  {rowsPerPage} from '../../Utils/constant'

function DuplicateAudits() {
  const navigate = useNavigate();
  const decodedToken = useDecodeToken();
  const [secondLastCenId,setSecondLastCenId] = useState("");
  const [currentCenId,setCurrentCenId] = useState("")
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const [auditId,setAuditId] = useState([])
  const [updateData, setUpDateData] = useState("");
  const [copyAudits] = useCopyAuditsMutation();
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);
const [error,setError]=useState("")
  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);
  const { data :cenData } = useGetCenQuery({
    search: "",
    limit: "",
    page: "",
  });


  const { data, isFetching, isLoading, refetch } = useGetCentreDataQuery({
    rrb_id: "",
    state_id: "",
    city_id: "",
    centre_id: "",
    search: "",
    limit: "",
    page: "",
    cen_id: secondLastCenId,
    approve_status:"approved"
  },{skip: !secondLastCenId});

useEffect(()=>{
if(cenData){
    setSecondLastCenId(cenData?.data?.data[1]?.id);
    setCurrentCenId(cenData?.data?.data[0]?.id);
}
},[cenData])

 const handlecancel =()=>{
    setAuditId([]);
 }

  const handleCopyAudits = async () => {

if(auditId?.length > 0){
  try {
    const response = await copyAudits({
      cen_id: currentCenId,
      audit_ids:auditId,
    });
    if (response?.data?.success) {
      setAuditId([]);
      setError("");
    }
  } catch (error) {
    console.log(error, "verify otp error");
  }
}else{
  setError({
    message:"Please Select Centers",
    type:"error"
  })
}
  };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
    setError("");
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      const allAuditIds = data?.data?.data.map((row) => row?.audits[0]?.id) || [];
      setAuditId(allAuditIds);
      setError("");
    } else {
      setAuditId([]);
    }
  };

  const handleRowSelect = (isChecked, row) => {
    const rowId = row?.audits[0]?.id
    if (isChecked) {
      setAuditId((prev) => [...prev, rowId]);
    } else {
      setAuditId((prev) => prev.filter((id) => id !== rowId));
    }
  };
  const columns = [
    {
        title: (
          <input
            type="checkbox"
            checked={data?.data?.data?.length > 0 && auditId.length === data.data.data.length}
          onChange={(e) => handleSelectAll(e.target.checked)}
           
          />
        ),
        render: (_, row) => (
          <input
            type="checkbox"
            checked={auditId.includes(row?.audits[0]?.id)}
          onChange={(e) => handleRowSelect(e.target.checked, row)}
            
          />
        ),
      },
  {
    title: "RRB",
    render: (_, row) => row?.city?.rrb?.name || "-",
  },
  {
    title: "Center Name",
    render: (_, row) => row?.name || "-",
  },
  {
    title: "Location",
    render: (_, row) => row?.address|| "-",
  },
     {
    title: "Previous Audit Status",
    // dataKey: "status",
    render: (_, row) => {
      let status = row?.status ? row?.status :"approved";
      const getBadgeColor = (row) => {
        switch (status) {
            case "approved":
              return "bg-approved_theame text-white";
          case "rejected":
            return "bg-rejected_theame text-white";
          default:
            return "bg-secondary text-white"; // Default gray badge for other statuses
        }
      };

      return (
        <div className="d-flex justify-content-center">
        <span
          className={`badge ${getBadgeColor(status)}`}
          style={{ padding: "8px 5px" }}
        >
          {status?.charAt(0).toUpperCase() + status?.slice(1)}
        </span>
        </div>
      );
    },
  },
  {
    title: "Previous Audit Date",
    render: (_,row) => {
        const aDate = row?.audits[0]?.audit_date;
      if (!aDate) return "N/A";
      const date = new Date(aDate);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },

    // {
    //   title: "Actions",
    //   render: (_, row) => (
        
    //     <div className="d-flex">
    //         <button
    //         className="border-0 bg-transparent"
    //         onClick={() => {
    //           setViewReAuditData(row);
    //           setViewReAudit(true);
    //         }}
    //       >
    //         <i class="fas fa-eye text-primary"></i>
    //       </button>
    //       {row?.status == "pending" ?
    //       <>
    //       <button
    //         className="border-0 bg-transparent"
    //         type="button"
    //         onClick={() => {
    //           setUpDateData({ ...row, status: "approved" });
    //           setShowForm(true);
    //         }}
    //       >
    //         <i class="fas fa-check text-success"></i>
    //       </button>
    //       <button
    //         className="border-0 bg-transparent"
    //         type="button"
            
    //         onClick={() => {
    //           setUpDateData({ ...row, status: "rejected" });
    //           setShowForm(true);
    //         }}
    //       >
    //         <i class="fas fa-window-close text-danger"></i>
    //       </button>
    //       </>
    //     :null
    //     }
    //     </div>
          
    //   ),
    // },
  ];


  return (
    <Layout>
      <DuplicateAuditsUi
        columns={columns}
        data={data?.data?.data || []}
        // data={[]}
        totalRecords={data?.data?.totalItems}
        loading={isLoading}
        tableQaury={tableQaury}
        onPageChange={handlePageChange}
        setTableQaury={setTableQaury}
        decodedToken={decodedToken}
        handleCopyAudits={handleCopyAudits}
        handlecancel={handlecancel}
        cenData={cenData?.data?.data}
       auditId={auditId}
       toast={error ? error :toast}
      />
    </Layout>
  );
}

export default DuplicateAudits;
